import {makeGetRefundModalities} from 'main/factories/usecases';

export const getRefundModalities = async (signal?: AbortSignal) => {
	const data = await makeGetRefundModalities().get({signal});

	return data.content.modalities;
};
